import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import {Signals} from "@/Imports";
import Utils from "@base/utils/Utils";
import RippleContainer from "./RippleContainer";
import Config from "../config/Config";
import SubmarineConfig from "@/config/SubmarineConfig";
import PlaneConfig from "@/config/PlaneConfig";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import gsap from 'gsap'

export default class WaterContainer extends BaseContainer {

    constructor(data) {
        super(data)

        this.init()
    }

    init() {
        Signals.forceRoundStart.add(this.reset, this)
        Signals.roundStart.add(this.start, this)
        Signals.roundEnd.add(this.onRoundEnd, this)
        Signals.makeBets.add(this.onMakeBets, this)
        Signals.multiplier.add(this.updateMultiplier, this)
        this.isHorisontal = false

        this.water = new PIXI.Container()
        this.addChild(this.water)

        this.ocean = new SpineAnimation('oceanAnim')
        this.ocean.position.set(0, 50)
        this.ocean.start(['oceanAnim'], [true], 0.5)

        const haze = new PIXI.Sprite(PIXI.Texture.from('haze'))
        haze.position.set(0, 0)
        haze.width = 2600
        this.addChild(this.ocean)
        this.water.addChild(haze)
    }

    reset() {
        Signals.tick.remove(this.update, this)
        this.water.x = 0
    }

    start() {
        this.isHorisontal = false

        gsap.to(this.ocean, 3, {timeScale: 1.3})
        //start(['oceanAnim'], [true], 0.1)
        Signals.tick.add(this.update, this)
    }

    onRoundEnd() {
        gsap.to(this.ocean, 1, {timeScale: 0.2})
        Signals.tick.remove(this.update, this)
    }

    onMakeBets() {
        this.isHorisontal = false
        this.water.x = 0
        gsap.to(this.ocean, 1, {timeScale: 0.05})
    }

    update() {
        if (!this.isHorisontal){
            return
        }
       this.water.x -= PlaneConfig.speed.x
       if(this.water.x < - this.water.width /2 + 200) {
           this.water.x = 0;
       }
    }

    updateMultiplier(multiplier) {
        this.currentFar = multiplier
        if ( !this.isHorisontal && this.currentFar > PlaneConfig.farStartMove) {
            //this.ocean.start(['oceanAnim'], [true], 0.5)
            // this.ocean.changeTimeScale(0.5)
        }
        this.isHorisontal = this.currentFar > PlaneConfig.farStartMove
    }

}
